import { Grid } from "@material-ui/core"
import { StaticImage } from "gatsby-plugin-image"
import React from "react"
import {
  StyledDetailHeader,
  StyledDetailLocation,
  StyledDetailSubheader,
  StyledDetailSubheaderContent,
} from "./MapTypography"
import { Fade } from "react-reveal"
import { Image } from "react-image-and-background-image-fade"
import cropin_logo from "../../images/cropin-logo.png"
import no_poverty from "../../images/no-poverty.png"
import zero_hunger from "../../images/zero-hunger.png"
import decent_work from "../../images/decent-work.png"

const CropinMapDetail = () => {
  return (
    <>
      <Grid container spacing={5}>
        <Grid item lg={3} xl={2}>
          <Image
            src={cropin_logo}
            width="628px"
            height="274px"
            isResponsive
            disableLoader
            alt="CropIn"
            style={{ backgroundSize: "cover", backgroundPosition: "center" }}
          />
        </Grid>
      </Grid>
      <Grid container spacing={5} alignItems="flex-end">
        <Grid item lg={3} xl={2} container spacing={2}>
          <Grid item xs={6}>
            <Image
              src={no_poverty}
              width="282px"
              height="282px"
              isResponsive
              disableLoader
              alt="no poverty"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
          </Grid>
          <Grid item xs={6}></Grid>
          <Grid item xs={6}>
            <Image
              src={zero_hunger}
              width="282px"
              height="282px"
              isResponsive
              disableLoader
              alt="zero hunger"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
          </Grid>
          <Grid item xs={6}>
            <Image
              src={decent_work}
              width="282px"
              height="282px"
              isResponsive
              disableLoader
              alt="decent work and economic growth"
              style={{ backgroundSize: "cover", backgroundPosition: "center" }}
            />
          </Grid>
        </Grid>
        <Grid item lg={9} xl={10} container>
          <Grid item xs={12}>
            <StyledDetailHeader>Agri-tech</StyledDetailHeader>
          </Grid>
          <Grid item xs={12}>
            <StyledDetailLocation>Based in India</StyledDetailLocation>
          </Grid>
          <Grid
            item
            xs={12}
            style={{
              borderBottom: "3px solid #0F6494",
              paddingTop: "12px",
              paddingBottom: "12px",
            }}
            container
            alignItems="center"
          >
            <Grid item xs={6}>
              <StyledDetailSubheader>Investment Theme</StyledDetailSubheader>
            </Grid>
            <Grid item xs={6}>
              <StyledDetailSubheaderContent>
                Sustainable Food & Agriculture
              </StyledDetailSubheaderContent>
            </Grid>
          </Grid>
          <Grid item xs={12}>
            <StyledDetailSubheader style={{ marginTop: "16px" }}>
              About the Company
            </StyledDetailSubheader>
            <StyledDetailSubheaderContent>
              Agri-tech platform enabling data-driven farming by connecting all
              stakeholders in the agri-ecosystem.
            </StyledDetailSubheaderContent>
            <StyledDetailSubheader style={{ marginTop: "16px" }}>
              Impact Thesis
            </StyledDetailSubheader>
            <StyledDetailSubheaderContent>
              Improving the productivity and livelihood of smallholder farmers
              and driving greater efficiency in agri supply-chains.
            </StyledDetailSubheaderContent>
          </Grid>
        </Grid>
      </Grid>
    </>
  )
}

export default CropinMapDetail
